import { Record } from 'immutable';

const LegalEntityRecord = Record({
  legalEntityId: null,
  vatNumberId: null,
  legalEntityName: null,
  country: null,
  address1: null,
  address2: null,
  address3: null,
  city: null,
  stateProvince: null,
  postalCode: null
});

export class LegalEntity extends LegalEntityRecord {
  legalEntityId: number;
  vatNumberId: string;
  legalEntityName: string;
  country: string;
  address1: string;
  address2: string;
  address3: string;
  city: string;
  stateProvince: string;
  postalCode: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/legal-entity.ts